import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Loader } from '@itds/elements/index.js';
import { CarrierCard } from '@itds/components/index.js';

import { Api } from '@brokerage/utils/Api';

const LimitCarriers = ({ annuity_quoter, handleSave }) => {
  const [data, setData] = useState({
    carrier_ids: annuity_quoter?.carrier_ids || [],
    product_ids: annuity_quoter?.product_ids || []
  });
  const [product_ids, setProductIds] = useState([]);
  const [carriers, setCarriers] = useState([]);
  const [carrier_ids, setCarrierIds] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    document.body.style.overflow = 'visible';
    getData();
  }, []);

  useEffect(() => {
    setData({
      carrier_ids: annuity_quoter?.carrier_ids || [],
      product_ids: annuity_quoter?.product_ids || []
    });
  }, [annuity_quoter]);

  const getData = () => {
    Api.loadAnnuityCarriers().then(response => {
      const carriers = response.data;

      setCarriers(carriers);
      setCarrierIds(carriers.map(c => c.id));
      setProductIds(carriers.map(c => c.products.map(p => p.id)).flat());
      setLoading(false);
    });
  };

  const handleSelectAll = () => {
    if (data.carrier_ids.length !== carrier_ids.length) {
      setData({
        product_ids,
        carrier_ids
      });
    } else {
      setData({ product_ids: [], carrier_ids: [] });
    }
  };

  const handleCarrierToggle = (carrier, checked) => {
    const is_selected = !checked;
    const carrierProductIdsSet = new Set(carrier.products.map(p => p.id));
    const selected_carrier_ids = data.carrier_ids.filter(id => id !== carrier.id);
    const selected_product_ids = data.product_ids.filter(id => !carrierProductIdsSet.has(id));

    if (is_selected) {
      selected_carrier_ids.push(carrier.id);
      selected_product_ids.push(...carrier.products.map(p => p.id));
    }

    setData({
      carrier_ids: selected_carrier_ids,
      product_ids: Array.from(new Set(selected_product_ids))
    });
  };

  const handleProductsChange = (carrier, p_ids) => {
    const carrierProductIdsSet = new Set(carrier.products.map(p => p.id));
    // Filter out previous product IDs belonging to this carrier
    const other_product_ids = data.product_ids.filter(id => !carrierProductIdsSet.has(id));
    // Only accept IDs that actually belong to this carrier to prevent accidental cross-carrier pollution
    const carrier_new_product_ids = p_ids.filter(id => carrierProductIdsSet.has(id));

    setData({
      carrier_ids: data.carrier_ids,
      product_ids: [...other_product_ids, ...carrier_new_product_ids]
    });
  };

  const save = data => {
    handleSave(data);
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <div style={{ marginBottom: '30px' }}>
        <Button inline={true} onClick={handleSelectAll.bind(null)} small={true}>
          {data.carrier_ids.length === carrier_ids.length ? 'Unselect All' : 'Select All'}
        </Button>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {carriers.map(carrier => {
              const is_selected = data.carrier_ids.includes(carrier.id);

              return (
                <CarrierCard
                  carrier={carrier}
                  isSelected={is_selected}
                  key={carrier.id}
                  lineOfBusiness='annuities'
                  onClick={handleCarrierToggle.bind(null, carrier, is_selected)}
                  onProductsSave={handleProductsChange.bind(null, carrier)}
                  products={carrier.products}
                  selectedProductIds={data.product_ids}
                />
              );
            })}
          </div>

          <Button inline={true} onClick={save.bind(null, data)}>
            Save Changes
          </Button>
        </>
      )}
    </>
  );
};

LimitCarriers.propTypes = {
  annuity_quoter: PropTypes.object,
  handleSave: PropTypes.func
};

export default LimitCarriers;
